import React, { FunctionComponent } from 'react';
import AtlassianSwitcher from '@atlaskit/atlassian-switcher';
import { IntlProvider } from 'react-intl';
import FabricAnalyticsListeners, {
  FabricChannel,
} from '@atlaskit/analytics-listeners';
import { Analytics } from '@trello/atlassian-analytics';
import { N300, N800 } from '@trello/colors';
import { ProductKeys } from '@atlassiansox/product-store-react';

import { useFeatureFlag } from '@trello/feature-flag-client';
import { JoinableSitesResponse } from '@atlaskit/atlassian-switcher/dist/cjs/types';
import { ExportedDataProvider } from '@atlaskit/atlassian-switcher/dist/cjs/providers/create-data-provider';

export enum AtlassianSwitcherVariations {
  CONTROL = 'control',
  NOT_ENROLLED = 'not-enrolled',
  EXPERIMENT = 'experiment',
}

const trelloTheme = {
  primaryTextColor: N800,
  secondaryTextColor: N300,
  primaryHoverBackgroundColor: '#E0E2E5',
  secondaryHoverBackgroundColor: '#F5F6F7',
};

interface AtlassianAppSwitcherProps {
  triggerXFlow: (productKey: ProductKeys) => void;
  onDiscoverMoreClicked: () => void;
  joinableSitesDataProvider: ExportedDataProvider<JoinableSitesResponse>;
}

export const AtlassianAppSwitcher: FunctionComponent<AtlassianAppSwitcherProps> = ({
  triggerXFlow,
  onDiscoverMoreClicked,
  joinableSitesDataProvider,
}) => {
  const switcherJoinVariation = useFeatureFlag(
    'aa4a.atlassian-switcher-joinable-sites',
    AtlassianSwitcherVariations.NOT_ENROLLED,
  );
  const isJoinEnabled =
    switcherJoinVariation === AtlassianSwitcherVariations.EXPERIMENT;
  let joinableSitesSwitcherProps = {};
  if (isJoinEnabled) {
    joinableSitesSwitcherProps = {
      joinableSitesDataProvider,
    };
  }

  const discoverySwitcherProps = {
    isDiscoverMoreForEveryoneEnabled: true,
    isDiscoverSectionEnabled: true,
    triggerXFlow,
    onDiscoverMoreClicked,
    recommendationsFeatureFlags: {
      isProductStoreInTrelloEnabled: true,
    },
  };
  return (
    <IntlProvider locale="en">
      {
        //@ts-ignore
        <FabricAnalyticsListeners
          client={Analytics.dangerouslyGetAnalyticsWebClient()}
          excludedChannels={[
            FabricChannel.atlaskit,
            FabricChannel.elements,
            FabricChannel.editor,
            FabricChannel.media,
          ]}
        >
          {
            //@ts-ignore
            <AtlassianSwitcher
              product="trello"
              appearance="standalone"
              theme={trelloTheme}
              {...discoverySwitcherProps}
              {...joinableSitesSwitcherProps}
            />
          }
        </FabricAnalyticsListeners>
      }
    </IntlProvider>
  );
};
